import Seo from "./Seo";
import { buildgeetgovindDescription, buildgeetgovindJsonLd, buildgeetgovindKeywords } from "../utils/geetgovindSeo";

type geetgovindSeoProps = {
  geetgovind: any;
  canonicalPath: string;
};

const geetgovindSeo = ({ geetgovind, canonicalPath }: geetgovindSeoProps) => {
    debugger;
  if (!geetgovind) return null;

  const title = geetgovind?.pageTitle || geetgovind?.ogTitle || (geetgovind?.name ? `${geetgovind.name} | Gita Seva` : "Gita Seva geetgovind");
  const description = geetgovind?.pageDescription || geetgovind?.ogDescription || buildgeetgovindDescription(geetgovind);
  const keywords = buildgeetgovindKeywords(geetgovind);
  const image = geetgovind?.ogImage || geetgovind?.geetgovindPath || "";
  const jsonLd = buildgeetgovindJsonLd(geetgovind, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="geetgovind"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default geetgovindSeo;






